import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-type',
  templateUrl: './payment-type.component.html',
  styleUrls: ['./payment-type.component.css']
})
export class PaymentTypeComponent implements OnInit {

  public menu_item_id = '17';
  public edit_auth;

  private dp = [];
  displayedColumns = ['payment_type_name', 'payment_type_per', 'max_limit'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'payment_type', 'payment_type_id': '', 'payment_type_per': '', 'max_limit': '' };
  // 'payment_type_name': '',

  Success_Msg; Error_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

  }

  ngOnInit() {
    // check edit authorization
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);

    let query = this.queryList.all_paymentType;
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  update() {
    let values = [];
    let where = [];

    this.dp.forEach((pt) => {
      let payment_type_per = document.getElementById('payment_type_per' + pt.payment_type_id) as HTMLInputElement;
      let max_limit = document.getElementById('max_limit' + pt.payment_type_id) as HTMLInputElement;

      // this.model['payment_type_id'] = pt.payment_type_id;
      // this.model['payment_type_per'] = payment_type_per.value;
      // this.model['max_limit'] = max_limit.value;
      // this.model['payment_type_name'] = pt.payment_type_name;

      where.push({ 'payment_type_id': pt.payment_type_id });
      values.push({
        'table_name': this.model['table_name'], 'payment_type_per': payment_type_per.value,
        'max_limit': max_limit.value
      });
    });

    let obj = { cmd: 'update', values: values, where: where };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
        }
        else if (data.status['type'] != 'success') {
          alert(this.Error_Msg);
        }
      });
  }

}
